module.exports = __webpack_public_path__ + "static/media/curve-gold.0818a656.svg";